import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled error in admin app tree:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cream px-6 text-center">
          <h1 className="font-display text-2xl font-bold text-navy-900">
            Something went wrong
          </h1>
          <p className="max-w-sm text-slate-500">
            The admin panel hit an unexpected error. Try reloading.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-iris-500 px-5 py-2.5 font-semibold text-white transition hover:bg-iris-600"
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
